/* Paqari — Product & Cart JS */
(function () {
  'use strict';

  /* ============================================================
     MOBILE NAV
     ============================================================ */
  var hamburger = document.querySelector('.nav-hamburger');
  var mobileMenu = document.querySelector('.nav-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var open = hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('click', function (e) {
      if (mobileMenu.classList.contains('open') &&
          !hamburger.contains(e.target) &&
          !mobileMenu.contains(e.target)) {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  // Cart icons (desktop nav + mobile actions) → open mini-cart drawer
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openMiniCart();
    });
  });

  /* ============================================================
     ACCORDION
     ============================================================ */
  document.querySelectorAll('.acc-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.acc-item');
      var wasOpen = item.classList.contains('open');
      // Close siblings in same accordion group
      var accordion = item.closest('.paqari-accordion');
      if (accordion) {
        accordion.querySelectorAll('.acc-item.open').forEach(function (el) {
          if (el !== item) el.classList.remove('open');
        });
      }
      item.classList.toggle('open', !wasOpen);
    });
  });

  /* ============================================================
     GALLERY — color-block thumbnail swap
     ============================================================ */
  var galleryMain = document.querySelector('.gallery-main');
  var thumbs = document.querySelectorAll('.gallery-thumb');

  if (galleryMain && thumbs.length) {
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        // Update active thumb
        thumbs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-pressed', 'false'); });
        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');

        var videoPanel = galleryMain.querySelector('.gallery-video');
        var video = videoPanel && videoPanel.querySelector('video');
        var isVideo = Boolean(this.dataset.videoTarget);
        var mainImage = galleryMain.querySelector(':scope > img');
        var caption = document.querySelector('.creator-video-caption');
        if (videoPanel) videoPanel.hidden = !isVideo;
        if (mainImage) mainImage.hidden = isVideo;
        if (caption) caption.hidden = !isVideo;
        if (video && !isVideo) video.pause();
        if (isVideo) return;

        // Swap main block's background color to match thumb
        var thumbBlock = this.querySelector('.color-block');
        var mainBlock  = galleryMain.querySelector('.color-block');
        if (thumbBlock && mainBlock) {
          var newBg = window.getComputedStyle(thumbBlock).backgroundColor;
          mainBlock.style.background = newBg;
        }

        // Also swap a real image if one exists
        var thumbImg = this.querySelector('img');
        var mainImg  = galleryMain.querySelector('img');
        if (thumbImg && mainImg) {
          mainImg.src    = thumbImg.src;
          mainImg.srcset = thumbImg.srcset || '';
          mainImg.alt    = thumbImg.alt;
        }
      });
    });

    // Set first thumb active
    if (thumbs[0]) { thumbs[0].classList.add('active'); thumbs[0].setAttribute('aria-pressed', 'true'); }
  }

  /* ============================================================
     PDP IMAGE LIGHTBOX — tap the main image to zoom full-screen
     (fixes mobile dead-clicks; vanilla JS, no library)
     ============================================================ */
  (function () {
    var main = document.querySelector('.gallery-main');
    if (!main) return;
    var box, boxImg, startY = 0, dragging = false;

    function hiRes(src) {
      if (!src) return src;
      return /([?&]width=)\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$11600')
        : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
    }

    function closeBox() {
      if (!box) return;
      box.style.opacity = '0';
      document.body.style.overflow = '';
      setTimeout(function () { if (box) { box.style.display = 'none'; } boxImg.style.transform = ''; }, 200);
    }

    function buildBox() {
      box = document.createElement('div');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-label', 'Product image');
      box.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.93);display:none;align-items:center;justify-content:center;opacity:0;transition:opacity 0.2s ease;touch-action:none;';

      boxImg = document.createElement('img');
      boxImg.style.cssText = 'max-width:92%;max-height:92%;object-fit:contain;user-select:none;-webkit-user-drag:none;transition:transform 0.05s linear;';
      box.appendChild(boxImg);

      var close = document.createElement('button');
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '&times;';
      close.style.cssText = 'position:absolute;top:12px;right:16px;width:44px;height:44px;font-size:34px;line-height:1;color:#fff;background:none;border:none;cursor:pointer;';
      close.addEventListener('click', closeBox);
      box.appendChild(close);

      box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });

      box.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startY = e.touches[0].clientY; dragging = true;
      }, { passive: true });
      box.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        var dy = e.touches[0].clientY - startY;
        boxImg.style.transform = 'translateY(' + dy + 'px)';
        box.style.opacity = String(Math.max(0.3, 1 - Math.abs(dy) / 400));
      }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (!dragging) return; dragging = false;
        var endY = e.changedTouches[0] ? e.changedTouches[0].clientY : startY;
        if (Math.abs(endY - startY) > 90) { closeBox(); }
        else { boxImg.style.transform = ''; box.style.opacity = '1'; }
      });

      document.body.appendChild(box);
    }

    function openBox(src, alt) {
      if (!box) buildBox();
      boxImg.src = hiRes(src);
      boxImg.alt = alt || '';
      boxImg.style.transform = '';
      box.style.display = 'flex';
      box.offsetHeight; // reflow so the fade-in transition runs
      box.style.opacity = '1';
      document.body.style.overflow = 'hidden';
    }

    main.addEventListener('click', function () {
      var videoPanel = main.querySelector('.gallery-video');
      if (videoPanel && !videoPanel.hidden) return;
      var img = main.querySelector('img');
      if (img && img.src) openBox(img.src, img.alt);
    });
    var mImg = main.querySelector('img');
    if (mImg) mImg.style.cursor = 'zoom-in';

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box && box.style.display === 'flex') closeBox();
    });
  })();

  /* ============================================================
     QUANTITY STEPPER
     ============================================================ */
  var qtyInput = document.querySelector('.qty-input');
  if (qtyInput) {
    document.querySelector('.qty-btn.qty-minus') &&
      document.querySelector('.qty-btn.qty-minus').addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
      });
    document.querySelector('.qty-btn.qty-plus') &&
      document.querySelector('.qty-btn.qty-plus').addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
  }

  /* ============================================================
     VARIANT / SWATCH SELECTION
     ============================================================ */
  var variantData   = window.paqariVariants || [];
  var selectedOpts  = {};
  var numOptions    = variantData.length ? variantData[0].options.length : 0;

  // Initialise from pre-selected variant
  (function () {
    var idInput = document.querySelector('[name="id"]');
    if (!idInput) return;
    var preId = parseInt(idInput.value, 10);
    variantData.forEach(function (v) {
      if (v.id === preId) {
        v.options.forEach(function (val, idx) {
          selectedOpts['option' + (idx + 1)] = val;
        });
      }
    });
  })();

  function findVariant() {
    return variantData.find(function (v) {
      return v.options.every(function (val, idx) {
        return selectedOpts['option' + (idx + 1)] === val;
      });
    }) || null;
  }

  function moneyFmt(cents) {
    return '$' + Math.round(cents / 100);
  }

  function moneyFmtFull(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\.00$/, '');
  }

  function updateUI(variant) {
    // Price
    var priceEl   = document.querySelector('.buy-price-amount');
    var compareEl = document.querySelector('.buy-price-compare');
    if (priceEl && variant) {
      priceEl.textContent = moneyFmt(variant.price);
    }
    if (compareEl) {
      if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFmt(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Installments
    var instEl = document.querySelector('.buy-installments');
    if (instEl && variant) {
      var installAmt = moneyFmt(Math.round(variant.price / 4));
      instEl.textContent = 'or 4 payments of ' + installAmt + ' with Shop Pay';
    }

    // Hidden id input
    var idInput = document.querySelector('[name="id"]');
    if (idInput && variant) idInput.value = variant.id;

    // ATC button
    var atcBtn = document.querySelector('.btn-atc');
    if (atcBtn) {
      if (!variant) {
        atcBtn.textContent = 'Unavailable';
        atcBtn.disabled = true;
      } else if (!variant.available) {
        atcBtn.textContent = 'Sold Out';
        atcBtn.disabled = true;
      } else {
        atcBtn.textContent = 'Add to Bag — ' + moneyFmt(variant.price);
        atcBtn.disabled = false;
      }
    }

    // Gallery swap on variant with featured image
    if (variant && variant.featured_image) {
      var mainImg = document.querySelector('.gallery-main img');
      if (mainImg) {
        mainImg.src = variant.featured_image.src;
        mainImg.alt = variant.featured_image.alt || '';
      }
    }

    // Color block swap — update main gallery block color to match swatch
    if (variant) {
      var activeSwatchEl = document.querySelector('.swatch-btn.active');
      var mainBlock = document.querySelector('.gallery-main .color-block');
      if (activeSwatchEl && mainBlock) {
        mainBlock.style.background = activeSwatchEl.style.background;
      }
    }
  }

  // Swatch clicks
  document.querySelectorAll('.swatch-btn[data-option-index]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = this.dataset.optionIndex;
      var val = this.dataset.optionValue;
      selectedOpts['option' + idx] = val;

      // Active state
      document.querySelectorAll('.swatch-btn[data-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.remove('active');
      });
      this.classList.add('active');

      // Label
      var label = document.querySelector('.option-value-name[data-option-index="' + idx + '"]');
      if (label) label.textContent = val;

      updateUI(findVariant());
    });
  });

  /* ============================================================
     ADD TO CART — the ONE place that talks to /cart/add.js and
     fires the Meta AddToCart pixel. Every add path (PDP, product
     cards, mini-cart quick-adds, drawer recommendations) goes
     through here so tracking can never drift per-path again.
     Resolves with the added line item; rejects with an Error
     carrying `.data` when Shopify returns a cart error.
     ============================================================ */
  function paqariAddToCart(variantId, opts) {
    opts = opts || {};
    var item = { id: parseInt(variantId, 10), quantity: opts.quantity || 1 };
    if (opts.properties && Object.keys(opts.properties).length) {
      item.properties = opts.properties;
    }
    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          var err = new Error(data.description || 'Could not add to cart');
          err.data = data;
          throw err;
        }
        var added = (data.items && data.items[0]) || data;
        // final_line_price is in cents → /100 for a USD dollar value
        if (added && typeof fbq !== 'undefined') {
          fbq('track', 'AddToCart', {
            content_ids: [item.id.toString()],
            content_type: 'product',
            value: added.final_line_price / 100,
            currency: 'USD'
          });
        }
        return added;
      });
  }
  window.paqariAddToCart = paqariAddToCart;

  /* ============================================================
     PRODUCT CARDS (homepage grid + collection page)
     Rendered by snippets/paqari-card.liquid; wired here via
     delegation so the sections carry no inline JS.
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-atc-btn[data-variant-id]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var productId = btn.dataset.productId;
      var orig = btn.textContent;
      btn.textContent = '—';
      btn.disabled = true;
      paqariAddToCart(btn.dataset.variantId)
        .then(function (added) {
          btn.textContent = orig;
          btn.disabled = false;
          refreshCartCount();
          openMiniCartAdded(added, productId);
        })
        .catch(function () {
          btn.textContent = orig;
          btn.disabled = false;
        });
      return;
    }
    // Whole card navigates; real links inside it handle themselves
    if (e.target.closest('a')) return;
    var card = e.target.closest('.paqari-card[data-url]');
    if (card) window.location.href = card.dataset.url;
  });

  /* ============================================================
     MINI CART DRAWER
     ============================================================ */
  var cartOverlay = document.getElementById('paqariCartOverlay');
  var cartDrawer  = document.getElementById('paqariCartDrawer');
  var cartClose   = document.getElementById('paqariCartClose');

  function showDrawerOpen() {
    if (cartOverlay) cartOverlay.classList.add('is-open');
    if (cartDrawer)  { cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
  }

  function openMiniCart() {
    var modeAdded = document.getElementById('mcModeAdded');
    var modeCart  = document.getElementById('mcModeCart');
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (modeAdded) modeAdded.style.display = 'none';
        if (modeCart)  modeCart.style.display  = '';
        renderMiniCart(cart);
        showDrawerOpen();
      })
      .catch(function () {});
  }

  function closeMiniCart() {
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    if (cartDrawer)  { cartDrawer.classList.remove('is-open'); cartDrawer.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  // Normalize a Shopify image URL into a small, fast-loading thumbnail:
  // force https (cart/add.js can return protocol-relative URLs), strip any
  // existing width param, then cap the width. This is what stops the drawer
  // from ever downloading a full-size original over a slow mobile connection.
  function sizedThumb(src, px) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var i = src.indexOf('?');
    var base = i > -1 ? src.slice(0, i) : src;
    var qs = (i > -1 ? src.slice(i + 1) : '').split('&').filter(function (kv) {
      return kv && !/^width=/i.test(kv);
    });
    qs.push('width=' + (px || 200));
    return base + '?' + qs.join('&');
  }

  // Build a thumbnail <img> that never flashes black: the .mc-thumb-img class
  // carries a cream background while pixels download (see paqari.css), and the
  // <img> removes itself on error so the container's CSS placeholder shows.
  function buildThumb(src, altText, px) {
    var sized = sizedThumb(src, px);
    if (!sized) return '';
    var alt = (altText || '').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    return '<img class="mc-thumb-img" src="' + sized + '" alt="' + alt + '"'
      + ' loading="eager" decoding="async" onerror="this.remove();">';
  }

  // Sized cart thumbnail with a graceful fallback. 200px covers an 80px box at
  // retina density while keeping the file tiny.
  function mcThumb(item, altText) {
    var src = (item && item.featured_image && item.featured_image.url) || (item && item.image) || '';
    if (!src) return '';   // empty -> container shows the CSS placeholder
    return buildThumb(src, altText, 200);
  }

  // Quick-add cards for the throw colorways (mini-cart cross-sell).
  // opts.all = show every colorway; otherwise exclude ones already in the cart.
  function colorwayQuickAdds(cart, opts) {
    opts = opts || {};
    var data = window.paqariColorways || [];
    if (!data.length) return '';
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (i) { inCart[i.variant_id] = true; });
    var items = data.filter(function (c) { return c.available && (opts.all || !inCart[c.id]); });
    if (!items.length) return '';
    var safe = function (s) { return (s || '').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
    var cards = items.map(function (c) {
      var img = buildThumb(c.img, c.title, 400);
      return '<div class="mc-rec-card">'
        + '<a href="' + c.url + '" class="mc-rec-img-wrap">' + img + '</a>'
        + '<div class="mc-rec-name">' + safe(c.title) + '</div>'
        + '<div class="mc-rec-price">' + moneyFmtFull(c.price) + '</div>'
        + '<button class="mc-rec-atc mc-qa-add" data-vid="' + c.id + '">Add</button>'
        + '</div>';
    }).join('');
    return '<div class="mc-recs"><div class="mc-recs-title">' + safe(opts.heading || 'Also available') + '</div>'
      + '<div class="mc-recs-grid">' + cards + '</div></div>';
  }

  function renderMiniCart(cart) {
    var itemsEl    = document.getElementById('paqariCartItems');
    var footerEl   = document.getElementById('paqariCartFooter');
    var subtotalEl = document.getElementById('paqariCartSubtotal');
    if (!itemsEl) return;

    if (!cart.item_count) {
      itemsEl.innerHTML = '<p class="minicart-empty">Your bag is empty.</p>'
        + colorwayQuickAdds(cart, { all: true, heading: 'The throws' });
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var safe    = function (s) { return (s || '').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
      var imgHtml = mcThumb(item, item.product_title);
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="minicart-item-variant">' + safe(item.variant_title) + '</div>'
        : '';
      html += '<div class="minicart-item" data-key="' + item.key + '">'
        + '<div class="minicart-item-img">' + imgHtml + '</div>'
        + '<div class="minicart-item-info">'
        +   '<div class="minicart-item-title">' + safe(item.product_title) + '</div>'
        +   variantHtml
        +   '<div class="minicart-item-price">' + moneyFmtFull(item.final_line_price) + '</div>'
        +   '<div class="minicart-item-qty">'
        +     '<button class="mc-qty-btn" data-key="' + item.key + '" data-action="minus" aria-label="Remove one">−</button>'
        +     '<span class="mc-qty-num">' + item.quantity + '</span>'
        +     '<button class="mc-qty-btn" data-key="' + item.key + '" data-action="plus" aria-label="Add one">+</button>'
        +     '<button class="mc-remove" data-key="' + item.key + '" aria-label="Remove ' + safe(item.product_title) + '">Remove</button>'
        +   '</div>'
        + '</div>'
        + '</div>';
    });
    itemsEl.innerHTML = html + colorwayQuickAdds(cart, { heading: 'Complete the set' });

    if (footerEl) footerEl.style.display = '';
    if (subtotalEl) subtotalEl.textContent = moneyFmtFull(cart.total_price);
  }

  // Close on overlay, .paqari-mc-close buttons, or Escape
  if (cartOverlay) cartOverlay.addEventListener('click', closeMiniCart);
  if (cartDrawer)  cartDrawer.addEventListener('click', function (e) {
    if (e.target.closest('.paqari-mc-close')) closeMiniCart();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeMiniCart();
  });

  var cartChangePending = false;

  function readCartResponse(response) {
    return response.json().then(function (cart) {
      if (!response.ok || !cart || !Array.isArray(cart.items) ||
          typeof cart.item_count !== 'number' || typeof cart.total_price !== 'number') {
        throw new Error(cart && cart.description || 'Your bag could not be updated. Please try again.');
      }
      return cart;
    });
  }

  function cartMessage(message) {
    document.querySelectorAll('[data-cart-error]').forEach(function (el) {
      el.textContent = message;
      el.hidden = !message;
    });
  }

  function changeCart(key, quantity, render) {
    if (cartChangePending) return;
    cartChangePending = true;
    cartMessage('');
    var controls = document.querySelectorAll('.mc-qty-btn, .mc-remove, .cart-qty-btn, .cart-qty-input, #cart-form [name="checkout"], #cart-form [name="update"]');
    controls.forEach(function (el) { el.disabled = true; });
    function apply(cart) {
      render(cart);
      document.querySelectorAll('.cart-badge').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count < 1;
      });
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(readCartResponse).then(apply).catch(function (error) {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(readCartResponse).then(apply).catch(function () {})
        .then(function () { cartMessage(error.message || 'Your bag could not be updated. Please try again.'); });
    }).finally(function () {
      cartChangePending = false;
      controls.forEach(function (el) { el.disabled = false; });
    });
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var button = e.target.closest('.mc-remove, .mc-qty-btn');
      if (!button || cartChangePending) return;
      var row = button.closest('.minicart-item');
      var number = row && row.querySelector('.mc-qty-num');
      if (!button.dataset.key || !number) return;
      var previous = parseInt(number.textContent, 10) || 1;
      var next = button.classList.contains('mc-remove') ? 0 :
        (button.dataset.action === 'minus' ? Math.max(1, previous - 1) : previous + 1);
      if (next !== previous) changeCart(button.dataset.key, next, renderMiniCart);
    });
  }

  // Quick-add (colorway) buttons inside the bag → add, then re-render the bag
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var b = e.target.closest('.mc-qa-add');
      if (!b) return;
      e.preventDefault();
      var vid = parseInt(b.dataset.vid, 10);
      if (!vid) return;
      var orig = b.textContent;
      b.textContent = '—'; b.disabled = true;
      paqariAddToCart(vid)
        .then(function () {
          return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) { renderMiniCart(cart); refreshCartCount(); })
        .catch(function () { b.textContent = orig; b.disabled = false; });
    });
  }

  /* ============================================================
     AESOP-STYLE "ADDED TO CART" DRAWER
     ============================================================ */
  function openMiniCartAdded(addedItem, productId) {
    var modeAdded = document.getElementById('mcModeAdded');
    var modeCart  = document.getElementById('mcModeCart');
    if (!modeAdded) return;

    // Switch mode
    modeAdded.style.display = '';
    if (modeCart) modeCart.style.display = 'none';

    // Render added item
    var addedItemEl = document.getElementById('mcAddedItem');
    if (addedItemEl && addedItem) {
      var safe  = function (s) { return (s || '').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
      var img   = mcThumb(addedItem, addedItem.product_title);
      var vline = (addedItem.variant_title && addedItem.variant_title !== 'Default Title')
        ? '<div class="mc-ai-variant">' + safe(addedItem.variant_title) + '</div>' : '';
      addedItemEl.innerHTML =
        '<div class="mc-ai-img">' + img + '</div>' +
        '<div class="mc-ai-info">' +
          '<div class="mc-ai-title">' + safe(addedItem.product_title) + '</div>' +
          vline +
          '<div class="mc-ai-row">' +
            '<span class="mc-ai-qty">Qty ' + addedItem.quantity + '</span>' +
            '<span class="mc-ai-price">' + moneyFmtFull(addedItem.final_price) + '</span>' +
          '</div>' +
        '</div>';
    }

    // Reset recs and other-items panel
    var recsEl = document.getElementById('mcRecs');
    if (recsEl) recsEl.style.display = 'none';
    var otherEl = document.getElementById('mcOtherItems');
    if (otherEl) otherEl.style.display = 'none';

    // Open drawer
    showDrawerOpen();

    // Show other items already in cart (so the full bag is visible)
    var otherListEl = document.getElementById('mcOtherList');
    if (otherEl && otherListEl && addedItem) {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var safeStr = function (s) { return (s || '').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
          var others = (cart.items || []).filter(function (i) {
            return i.variant_id !== addedItem.variant_id;
          });
          if (!others.length) return;
          var html = '<div class="mc-other-hdr">Also in your bag</div>';
          others.forEach(function (item) {
            var img = mcThumb(item, item.product_title);
            html +=
              '<div class="mc-other-item">' +
                '<div class="mc-other-img">' + img + '</div>' +
                '<div class="mc-other-info">' +
                  '<div class="mc-other-name">' + safeStr(item.product_title) + '</div>' +
                  '<div class="mc-other-qty">Qty ' + item.quantity + '</div>' +
                '</div>' +
                '<div class="mc-other-price">' + moneyFmtFull(item.final_price) + '</div>' +
              '</div>';
          });
          otherListEl.innerHTML = html;
          otherEl.style.display = '';
        })
        .catch(function () {});
    }

    // Fetch Shopify recommendations
    if (productId) {
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var recs = (data.products || []).filter(function (p) { return p.available; }).slice(0, 4);
          if (!recs.length) return;
          var gridEl = document.getElementById('mcRecsGrid');
          if (!gridEl) return;

          var html = '';
          recs.forEach(function (p) {
            // /recommendations/products.json returns featured_image / images[] as
            // URL strings (not objects). Route through buildThumb for safe sizing
            // and the cream load background (no black flash).
            var rawSrc  = p.featured_image || (p.images && p.images[0]) || '';
            var imgTag  = buildThumb(rawSrc, p.title, 400);
            var price   = p.variants && p.variants[0] ? moneyFmtFull(p.variants[0].price) : '';
            var vid     = p.variants && p.variants[0] ? p.variants[0].id : '';
            html += '<div class="mc-rec-card">' +
              '<a href="' + p.url + '" class="mc-rec-img-wrap">' + imgTag + '</a>' +
              '<div class="mc-rec-name">' + (p.title || '').replace(/</g, '&lt;') + '</div>' +
              '<div class="mc-rec-price">' + price + '</div>' +
              (vid ? '<button class="mc-rec-atc" data-vid="' + vid + '">Add</button>' : '') +
            '</div>';
          });
          gridEl.innerHTML = html;
          if (recsEl) recsEl.style.display = '';

          // Wire rec ATC buttons
          gridEl.querySelectorAll('.mc-rec-atc').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var vId = parseInt(btn.dataset.vid, 10);
              var orig = btn.textContent;
              btn.textContent = '—'; btn.disabled = true;
              paqariAddToCart(vId)
                .then(function () {
                  btn.textContent = 'Added';
                  refreshCartCount();
                })
                .catch(function () { btn.textContent = orig; btn.disabled = false; });
            });
          });
        })
        .catch(function () {});
    }
  }

  /* ============================================================
     AJAX ADD TO CART (PDP)
     ============================================================ */
  var atcBtn = document.querySelector('.btn-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var idInput = document.querySelector('[name="id"]');
      var qty     = parseInt((document.querySelector('.qty-input') || {}).value || '1', 10);
      if (!idInput || !idInput.value) return;

      var orig = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      paqariAddToCart(idInput.value, { quantity: qty })
        .then(function () {
          atcBtn.textContent = 'Added to Bag ✓';
          refreshCartCount();
          openMiniCart();
          setTimeout(function () { atcBtn.textContent = orig; atcBtn.disabled = false; }, 1600);
        })
        .catch(function (err) {
          if (err && err.data) {
            // Shopify cart error (e.g. sold out) — show it briefly
            atcBtn.textContent = err.message;
            atcBtn.disabled = false;
            setTimeout(function () { atcBtn.textContent = orig; }, 2400);
          } else {
            atcBtn.textContent = orig;
            atcBtn.disabled = false;
          }
        });
    });
  }

  // Mobile sticky bar → trigger the main Add to Bag (reuses all its logic)
  var stickyAtc = document.querySelector('.pdp-sticky-atc');
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function () {
      var main = document.querySelector('.btn-atc');
      if (main) main.click();
    });
  }

  /* ============================================================
     CART COUNT BADGE
     ============================================================ */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-badge').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count < 1;
        });
      });
  }

  /* ============================================================
     CART PAGE QTY BUTTONS
     ============================================================ */
  function renderCartPage(cart) {
    document.querySelectorAll('.cart-line').forEach(function (line) {
      var button = line.querySelector('.cart-qty-btn');
      var item = cart.items.find(function (i) { return button && i.key === button.dataset.key; });
      if (!item) { line.remove(); return; }
      line.querySelector('.cart-qty-input').value = item.quantity;
      line.querySelector('.cart-line-total').textContent = moneyFmtFull(item.final_line_price);
      line.querySelector('.cart-line-price').textContent = moneyFmtFull(item.final_price);
    });
    var subtotal = document.querySelector('.cart-subtotal-price');
    var checkout = document.querySelector('#cart-form [name="checkout"]');
    if (subtotal) subtotal.textContent = moneyFmtFull(cart.total_price);
    if (checkout) checkout.textContent = 'Proceed to Checkout — ' + moneyFmtFull(cart.total_price);
    if (!cart.item_count) {
      var form = document.getElementById('cart-form');
      if (form) form.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a href="/" class="btn btn-solid">Continue shopping</a></div>';
    }
  }

  document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('.cart-qty-input');
      if (!input || !this.dataset.key || cartChangePending) return;
      var previous = parseInt(input.value, 10) || 0;
      var next = this.dataset.action === 'minus' ? Math.max(0, previous - 1) : previous + 1;
      if (next !== previous) changeCart(this.dataset.key, next, renderCartPage);
    });
  });
  var cartForm = document.getElementById('cart-form');
  if (cartForm) cartForm.addEventListener('submit', function (event) {
    if (cartChangePending) event.preventDefault();
  });

  /* ============================================================
     NEWSLETTER FORM (graceful fallback)
     ============================================================ */
  var nlForm = document.querySelector('.paqari-newsletter-form');
  if (nlForm) {
    // Show success message if Shopify redirected back with success param
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var successEl = nlForm.querySelector('.newsletter-success');
      if (successEl) successEl.classList.add('visible');
    }
  }
})();

/* ============================================================
   MOBILE STICKY ATC — scroll-triggered via IntersectionObserver
   Show the sticky bar whenever the main Add to Bag button (#pdp-atc-btn)
   is OUT of the viewport (including on first load, since the button sits
   below the fold on phones); hide it while the main button is on screen.
   Visibility is purely the CSS class `paq-sticky--visible`, which
   only renders on mobile (≤768px), so it never shows on desktop.
   ============================================================ */
(function () {
  function initStickyObserver() {
    var bar = document.querySelector('.pdp-sticky-bar');
    var mainAtc = document.getElementById('pdp-atc-btn');
    if (!bar || !mainAtc || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // main Add to Bag button on screen → hide sticky bar
        // main button off screen (above or below) → show sticky bar
        bar.classList.toggle('paq-sticky--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(mainAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyObserver);
  } else {
    initStickyObserver();
  }
})();
